<template>
  <div :class="{ alert: true, high: currentAlert.level == 'high', low: currentAlert.level == 'low', 'slide-out': !currentAlert.show, 'z-index-20-bg': true }">
    <p>{{ currentAlert.message }}</p>
  </div>
</template>

<script>
import useAlerts from '@/composables/useAlerts';

export default {
  name: 'Alert',
  setup() {
    const { currentAlert } = useAlerts();

    return {
      currentAlert,
    };
  },
};
</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  background: transparent;
  width: 100%;
  display: flex;
  pointer-events: none;

  p {
    padding: 0.5rem 0.9rem 0.45rem 0.9rem;
    margin: 0 auto;
    border-radius: $borderRadius5;
    color: white;
    font-size: $fontSize15;
  }

  animation: slideIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  @keyframes slideIn {
    from {
      top: 3rem;
      opacity: 0;
    }
    to {
      top: 6rem;
      opacity: 1;
    }
  }

  &.slide-out {
    animation: slideOut 0.3s ease-in-out forwards;
  }

  @keyframes slideOut {
    from {
      top: 6rem;
      opacity: 1;
    }
    to {
      top: 3rem;
      opacity: 0;
    }
  }
}

.high {
  p {
    background-color: $alertColor;
  }
}

.low {
  p {
    background-color: $headerBackground;
  }
}
</style>
